/* ============================================================
   OS9 COOKIE CONSENT BANNER
   squiche.com — 2026-06-15

   Replaces Shopify's auto-injected privacy banner with a Mac OS
   alert-style dialog. Markup is rendered by snippets/os9-cookie-banner.liquid.

   Behavior:
     1. On load, check Shopify Customer Privacy API for an existing
        consent record. If one exists, do nothing.
     2. Otherwise, show the OS9 dialog.
     3. On Accept: call setTrackingConsent with all permissions = true.
     4. On Reject: call setTrackingConsent with all permissions = false.
     5. Remember the choice in localStorage so we never re-prompt even
        across API outages.

   Requires Shopify's auto cookie banner to be DISABLED in
   Shopify admin → Settings → Customer privacy → Cookie banner.
   ============================================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'os9_cookie_consent_v1';
  var banner = document.getElementById('os9-cookie-banner');
  if (!banner) return;

  function show() { banner.setAttribute('data-open', '1'); }
  function hide() { banner.removeAttribute('data-open'); }

  /* localStorage backup — read first to avoid a flash before the API loads */
  var stored = null;
  try { stored = localStorage.getItem(STORAGE_KEY); } catch (e) { /* private mode */ }
  if (stored === 'accepted' || stored === 'rejected') {
    return; /* user already chose — never show again */
  }

  function recordChoice(accepted) {
    try { localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'rejected'); } catch (e) {}
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics:    accepted,
        marketing:    accepted,
        preferences:  accepted,
        sale_of_data: accepted
      }, function () { /* fire-and-forget — choice is already in localStorage */ });
    }
    hide();
  }

  /* Wire buttons (delegated so we don't have to query each one) */
  banner.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cookie-action]');
    if (!btn) return;
    var action = btn.dataset.cookieAction;
    if (action === 'accept') recordChoice(true);
    else if (action === 'reject') recordChoice(false);
  });

  /* Escape key closes as if Reject — matches Mac alert convention */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && banner.getAttribute('data-open') === '1') {
      recordChoice(false);
    }
  });

  /* Decide whether to show. Three signals checked, in order:
       1. Shopify.customerPrivacy.currentVisitorConsent() if API ready
       2. Shopify.loadFeatures consent-tracking-api (loads API, then re-check)
       3. Bare timer fallback — if Shopify.js never loads, show after 1s */
  function visitorAlreadyChose() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return null; /* unknown */
    try {
      var c = window.Shopify.customerPrivacy.currentVisitorConsent &&
              window.Shopify.customerPrivacy.currentVisitorConsent();
      if (!c) return false;
      /* API returns 'yes' / 'no' / '' for each key — any non-empty = recorded */
      return (c.analytics && c.analytics !== '') ||
             (c.marketing && c.marketing !== '') ||
             (c.preferences && c.preferences !== '') ||
             (c.sale_of_data && c.sale_of_data !== '');
    } catch (e) { return null; }
  }

  function decideAndShow() {
    var chose = visitorAlreadyChose();
    if (chose === true) return; /* already recorded — skip */
    show();
  }

  if (visitorAlreadyChose() === null && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function () { decideAndShow(); }
    );
  } else if (visitorAlreadyChose() !== true) {
    /* Either API was ready (and visitor hasn't chosen) or Shopify.js isn't
       available — show the banner regardless. Worst case: choice persists
       only in localStorage, which is fine for our purposes. */
    decideAndShow();
  }

  /* Safety net: if both API and DOM ready paths somehow fail, show after 1.5s */
  setTimeout(function () {
    if (banner.getAttribute('data-open') !== '1' && visitorAlreadyChose() !== true) {
      var s = null;
      try { s = localStorage.getItem(STORAGE_KEY); } catch (e) {}
      if (s !== 'accepted' && s !== 'rejected') show();
    }
  }, 1500);
})();
